import { Formik } from 'formik';
import React, { useCallback } from 'react';
import { cancelService, initialFilter } from 'v2/services/reports/cancel';

import type { ICancelFilter } from 'v2/interfaces/reports/cancel';

import Form from './Form';
import { FilterSchema } from './validations';

import type { FormikProps } from 'formik';

export function Filter() {
  const onSubmit = useCallback((values: ICancelFilter, { setSubmitting }: FormikProps<ICancelFilter>) => {
    cancelService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
      <Form />
    </Formik>
  );
}
